import { __assign, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { DateInput } from './components/DateInput';
import { InputGroupsWithDatePickerBasic, InputGroupsWithDatePickerBasicPropTypes, } from './InputGroupsWithDatePickerBasic';
import { InputGroupsPropTypes } from './InputGroups';
export var InputGroupsWithDatePicker = function (_a) {
    var id = _a.id, label = _a.label, groups = _a.groups, value = _a.value, onChange = _a.onChange, inputGroupsProps = _a.inputGroupsProps, datePickerProps = _a.datePickerProps;
    var _b = React.useState(), currentMonth = _b[0], setCurrentMonth = _b[1];
    return (React.createElement(InputGroupsWithDatePickerBasic, { id: id, groups: groups, DateInputs: function (_a) {
            var setVisible = _a.setVisible, inputGroupsPropsRest = __rest(_a, ["setVisible"]);
            return (React.createElement(DateInput, __assign({ label: label, style: { width: '100%' } }, inputGroupsPropsRest, { value: value, onChange: onChange, onFocus: function () { return setVisible(true); }, groups: groups })));
        }, inputGroupsProps: inputGroupsProps, datePickerProps: __assign(__assign({}, datePickerProps), { onDayClick: onChange, onClear: function () { return onChange(null); }, selectedDays: value != null ? value : undefined, onMonthChange: setCurrentMonth, month: currentMonth }) }));
};
InputGroupsWithDatePicker.propTypes = __assign(__assign({}, (function () {
    var DateInputs = InputGroupsWithDatePickerBasicPropTypes.DateInputs, otherBasicPropTypes = __rest(InputGroupsWithDatePickerBasicPropTypes, ["DateInputs"]);
    return otherBasicPropTypes;
})()), { datePickerProps: PropTypes.shape({
        id: PropTypes.string,
        onDayClick: PropTypes.func,
        onClose: PropTypes.func,
        onCloseText: PropTypes.string,
        onClear: PropTypes.func,
        onClearText: PropTypes.string,
        monthLabel: PropTypes.string,
        yearLabel: PropTypes.string,
        title: PropTypes.string,
        className: PropTypes.string,
    }), inputGroupsProps: PropTypes.shape((function () {
        var id = InputGroupsPropTypes.id, value = InputGroupsPropTypes.value, groups = InputGroupsPropTypes.groups, onChange = InputGroupsPropTypes.onChange, ShortenedPropTypes = __rest(InputGroupsPropTypes, ["id", "value", "groups", "onChange"]);
        return __assign({}, ShortenedPropTypes);
    })()), label: PropTypes.string.isRequired, value: PropTypes.instanceOf(Date), onChange: PropTypes.func.isRequired });
//# sourceMappingURL=InputGroupsWithDatePicker.js.map